export default class HeaderController {
    constructor() {
        this.headerElement = null;
        this.menuButton = null;
        this.searchbutton = null;

        this.previousScroll = 0;
        this.scrollCounter = 0;
        this.threshold = 180; // Hardcoded to header's desktop size

        this.init();
        this.resize();
    }

    init() {
        this.headerElement = document.querySelector('header');

        this.menuButton = this.headerElement.querySelector('.menuButton');
        this.searchbutton = this.headerElement.querySelector('.searchButton');

        // Register events
        window.app.registerResizeEvent(this.resize.bind(this));
        window.app.registerScrollEvent(this.scroll.bind(this));

        // Click events
        if (this.menuButton) {
            this.menuButton.addEventListener('click', this.toggleMenu.bind(this));
        }
        if (this.searchbutton) {
            this.searchbutton.addEventListener('click', (e) => {
                e.preventDefault();
                this.normalView();
                this.headerElement.querySelector('form.searchForm input[name="q"]').focus();
            });
        }
    }

    toggleMenu() {
        this.headerElement.classList.toggle('mobileMenuActive');
    }

    resize() {
        // this.previousScroll = window.scrollY;
        // this.threshold = this.headerElement.clientHeight;

        this.scroll();
    }

    scroll() {
        if (window.scrollY > this.threshold) {
            this.minifiedView();
        } else {
            this.normalView();
        }
    }

    minifiedView() {
        this.headerElement.classList.add('minified');
    }

    normalView() {
        this.headerElement.classList.remove('minified');
    }
}
